<template>
	<label :for='"file_input_media"+unKey' class='media-slot' ref='uplfile'>
		<input @change='uploadFile($event)'
			:id='"file_input_media"+unKey'
			ref='inp'
			type='file'
			accept='image/png, image/gif, image/jpeg, .pdf, .doc, .docx, .xls, .xlsx, .PDF, .DOC, .DOCX, .XLS, .XLSX'
			class='input_media'
		>
		<slot name='default' />
	</label>
</template>

<script>
import global from '__jsVueMixin/global';
export default {
	name:   'MediaTypeFileSlot',
	mixins:     [global],
	props:  {
		value: {
			type: Object,
			default() {
				return {
					id:    false,
					file: {
						src:  '',
						blob: false
					}
				};
			}
		},
	},
	created() {
		this.unKey = this.generateId('Media');
	},
	data() {
		return {
			events: [
				'dragenter', 'dragover', 'dragleave', 'drop'
			],
			dropArea: null,
			load:     false,
		};
	},
	mounted: function() {
		var that = this;
		if (this.$refs.upl) {
			this.addListeners();
		}
	},
	computed: {
		model: {
			get() {
				return this.value;
			},
			set(newVal) {
				this.$emit('input', newVal);
			}
		}
	},
	methods: {
		openExplorer() {
			this.$refs['uplfile'].click();
		},
		uploadFile: function(e) {
			var that = this;
			let file = e.target.files[0];
			if (!/\.(pdf|doc|docx|xls|xlsx|PDF|DOC|DOCX|XLS|XLSX|gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
				alert('File  is not valid');
				return false;
			}

			let reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = (e) => {
				this.$emit('upload', {
					unKey:  that.unKey,
					name:   file.name,
					format:   file.name.split('.').pop(),
					file:   reader.result,
				});

				this.$emit('file-added');
			};
			// reader.readAsArrayBuffer(file);
			e.target.value = '';
		},
		preventDefaults(e) {
			e.preventDefault();
			e.stopPropagation();
		},
		highlight() {
			this.dropArea.parentElement.classList.add('is-active');
		},
		unhighlight() {
			this.dropArea.parentElement.classList.remove('is-active');
		},
		handleDrop(e) {
			let files = e.dataTransfer.files;
			let file = files[0];
			if (files.length === 1) {
				if (/(pdf|doc|docx|xls|xlsx|PDF|DOC|DOCX|XLS|XLSX|gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)/.test(file.type)) {
					if (file.size < 10485760) {
						var that = this;
						let reader = new FileReader();
						reader.readAsDataURL(file);
						reader.onload = (e) => {
							this.$emit('upload', {
								unKey:  that.unKey,
								name:   file.name,
								format:   file.name.split('.').pop(),
								file:   reader.result,
							});
						};
						// reader.readAsArrayBuffer(file);
					}
					else this.params.error = 'file size > 10Mb';
				}
				else this.params.error = 'only files (*.pdf, *.doc|docx, *.xls|xlsx, *.jpg, *.png, *.svg)';
			}
			else this.params.error = 'No more than one file';
		},
		addListeners() {
			this.dropArea = this.$refs.upl;
			this.events.forEach(eventName => {
				this.dropArea.addEventListener(eventName, this.preventDefaults, false);
			});
			['dragenter', 'dragover'].forEach(eventName => {
				this.dropArea.addEventListener(eventName, this.highlight, false);
			});
			['dragleave', 'drop'].forEach(eventName => {
				this.dropArea.addEventListener(eventName, this.unhighlight, false);
			});
			this.dropArea.addEventListener('drop', this.handleDrop, false);
		},
	}
};
</script>
